import instance from '../../../../api/axios'
import {
  CreateActor,
  CreateDirector,
  CreateMovie,
  MovieItem,
  MovieListRequest,
  MoviePersonItem,
  PaginatedResponse,
} from '../types/movie'

export const loadMovies = async (): Promise<MovieItem[]> => {
  const response = await instance.get('/movies/all')
  return response.data
}

export const saveMovie = async (movie: CreateMovie): Promise<MovieItem> => {
  const response = await instance.post('/movies', movie)
  return response.data
}

export const loadActors = async (): Promise<MoviePersonItem[]> => {
  const response = await instance.get('/movies/actors/all')
  return response.data
}

export const loadDirectors = async (): Promise<MoviePersonItem[]> => {
  const response = await instance.get('/movies/directors/all')
  return response.data
}

const buildMovieListParams = (request: MovieListRequest) => {
  const params: Record<string, string> = {}

  params.page = String(request.page)
  params.limit = String(request.limit || 50)
  params.sortField = request.sortField
  params.sortDirection = request.sortDirection

  if (
    request.tab === 'movies' ||
    request.tab === 'series' ||
    request.tab === 'animations'
  ) {
    params.category = request.tab

    if (request.filters.name.trim()) {
      params.name = request.filters.name.trim()
    }

    if (request.filters.genre.trim()) {
      params.genre = request.filters.genre.trim()
    }

    if (request.filters.year.trim()) {
      params.year = request.filters.year.trim()
    }

    if (request.filters.status.trim()) {
      params.status = request.filters.status.trim()
    }

    if (request.filters.actor.trim()) {
      params.actor = request.filters.actor.trim()
    }

    if (request.filters.director.trim()) {
      params.director = request.filters.director.trim()
    }

    if (request.filters.rating.trim()) {
      params.rating = request.filters.rating.trim()
      params.ratingOperator = request.filters.ratingOperator || 'greater'
    }

    return params
  }

  if (request.filters.name.trim()) {
    params.name = request.filters.name.trim()
  }

  return params
}

export const loadMovieList = async (
  request: MovieListRequest,
): Promise<PaginatedResponse<MovieItem | MoviePersonItem>> => {
  const endpoint =
    request.tab === 'actors'
      ? '/movies/actors'
      : request.tab === 'directors'
      ? '/movies/directors'
      : '/movies'

  const response = await instance.get(endpoint, {
    params: buildMovieListParams(request),
  })

  return response.data
}

export const saveActor = async (
  actor: CreateActor,
): Promise<MoviePersonItem> => {
  const response = await instance.post('/movies/actors', actor)
  return response.data
}

export const saveDirector = async (
  director: CreateDirector,
): Promise<MoviePersonItem> => {
  const response = await instance.post('/movies/directors', director)
  return response.data
}

export const modifyMovie = async (movie: MovieItem): Promise<MovieItem> => {
  const response = await instance.put('/movies', movie)
  return response.data
}

export const modifyActor = async (
  actor: MoviePersonItem,
): Promise<MoviePersonItem> => {
  const response = await instance.put('/movies/actors', actor)
  return response.data
}

export const modifyDirector = async (
  director: MoviePersonItem,
): Promise<MoviePersonItem> => {
  const response = await instance.put('/movies/directors', director)
  return response.data
}

export const removeMovie = async (id: string): Promise<string> => {
  const response = await instance.delete(`/movies/${id}`)
  return response.data
}

export const removeActor = async (id: string): Promise<string> => {
  const response = await instance.delete(`/movies/actors/${id}`)
  return response.data
}

export const removeDirector = async (id: string): Promise<string> => {
  const response = await instance.delete(`/movies/directors/${id}`)
  return response.data
}
